export const TypeWriter = (input: string, delay: number, targetEl: Element, splitter?: string | null): void =>  {
    let i = 0
    let splitted: string[] = []
    if (splitter) {
        splitted = input.split(splitter)
    }
    targetEl.innerHTML = ''
    const interval = setInterval(() => {
      if (i < (splitted.length ?? input.length)) {
        targetEl.innerHTML += splitter ?? ''
        targetEl.innerHTML += splitted[i] ?? input.charAt(i)
        i++
      } else {
        clearInterval(interval)
      }
    }, delay)
  }